import './EditorGroup.sass';

export const EditorGroup = ({children}) => <div className="editor-group">{children}</div>;
